// extracted by mini-css-extract-plugin
export var copyableField = "_ru-4";
export var customerBadge = "_ru-0";
export var customerInfoTitle = "_ru-2";
export var details = "_ru-1";
export var dropdownContainer = "_ru-5";
export var dropdownImage = "_ru-6";
export var editAssigneeForm = "_ru-a";
export var editButton = "_ru-3";
export var email = "_ru-7";
export var hidden = "_ru-d";
export var input = "_ru-8";
export var saveButton = "_ru-b";
export var shopifyIcon = "_ru-c";
export var suggestionBadge = "_ru-e";
export var suggestionText = "_ru-f";
export var username = "_ru-9";